function propsEvalOrReturn(value, props) {
  var result = value;

  while (typeof result === 'function') {
    result = result(props);
  }

  return result;
}

export { propsEvalOrReturn };
